import React, { useState, useEffect, useRef } from "react";
import {
  GoogleMap,
  Autocomplete,
  DirectionsRenderer,
  useJsApiLoader,
} from "@react-google-maps/api";
import axios from "axios";
import { getDistance } from "geolib";

const containerStyle = {
  width: "100%",
  height: "80vh",
};

const center = {
  lat: 9.0108, // Default (Addis Ababa)
  lng: 38.7613,
};

const Dispatch = () => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyAbJIqSfbwgfz4NfYdcGQNEc-d01WeSKgw", // Replace with your actual API key
    libraries: ["places"],
  });

  const [source, setSource] = useState("");
  const [destination, setDestination] = useState("");
  const [directions, setDirections] = useState(null);
  const [distance, setDistance] = useState("");
  const [duration, setDuration] = useState("");
  const [sourceLatLng, setSourceLatLng] = useState(null);
  const [destLatLng, setDestLatLng] = useState(null);
  const [driverLists, setDriverLists] = useState([]);
  const [driverLoader, setDriverLoader] = useState(false);
  const [wsConnected, setWsConnected] = useState(false);
  const [showMap, setShowMap] = useState(false); // State to control map visibility

  const sourceRef = useRef(null);
  const destRef = useRef(null);
  const ws = useRef(null); // Fixed WebSocket ref initialization

  const initializeWebSocket = () => {
    ws.current = new WebSocket("ws://localhost:8080");
    ws.current.onopen = () => {
      console.log("Connected to WebSocket server");
      setWsConnected(true);
    };
    ws.current.onmessage = async (event) => {
      try {
        const message = JSON.parse(event.data);
        if (message.type === "nearbyDrivers") {
          await getDriversData(message.drivers);
        } else if (message.type === "error") {
          console.error("WebSocket error response:", message.message);
        }
      } catch (error) {
        console.error("Error parsing WebSocket data:", error);
      }
    };
    ws.current.onerror = (e) => {
      console.error("WebSocket error:", e);
      setWsConnected(false);
    };
    ws.current.onclose = (e) => {
      console.log("WebSocket closed:", e.code, e.reason);
      setWsConnected(false);
      // Attempt to reconnect after a delay
      setTimeout(() => {
        initializeWebSocket();
      }, 5000);
    };
  };

  useEffect(() => {
    initializeWebSocket();
    return () => {
      if (ws.current) {
        ws.current.close();
      }
    };
  }, []);

  // Load from localStorage on mount
  useEffect(() => {
    const savedSource = localStorage.getItem("source");
    const savedDestination = localStorage.getItem("destination");
    const savedDistance = localStorage.getItem("distance");
    const savedDuration = localStorage.getItem("duration");

    if (savedSource) setSource(savedSource);
    if (savedDestination) setDestination(savedDestination);
    if (savedDistance) setDistance(savedDistance);
    if (savedDuration) setDuration(savedDuration);
  }, []);

  // Save to localStorage when updated
  useEffect(() => {
    localStorage.setItem("source", source);
    localStorage.setItem("destination", destination);
    localStorage.setItem("distance", distance);
    localStorage.setItem("duration", duration);
  }, [source, destination, distance, duration]);

  const getDriversData = async (drivers) => {
    try {
      const driverIds = drivers.map((driver) => driver.id).join(",");

      console.log("driver id: ", drivers);
      const response = await axios.get(
        "https://binberu.idaprocharity.com/api/v1/driver/get-drivers-data",
        { params: { ids: driverIds } }
      );

      const driverData = response.data.map((driver) => ({
        ...driver,
        latitude: drivers.find((d) => d.id === driver.id)?.latitude || 0,
        longitude: drivers.find((d) => d.id === driver.id)?.longitude || 0,
        distance: sourceLatLng
          ? getDistance(
              { latitude: sourceLatLng.lat, longitude: sourceLatLng.lng },
              {
                latitude:
                  drivers.find((d) => d.id === driver.id)?.latitude || 0,
                longitude:
                  drivers.find((d) => d.id === driver.id)?.longitude || 0,
              }
            )
          : 0,
      }));

      console.log("Driver data:", driverData);
      setDriverLists(driverData);
      setDriverLoader(false);
    } catch (error) {
      console.error("Error fetching driver data:", error);
      setDriverLoader(false);
    }
  };

  const handleGetAction = () => {
    if (!isLoaded) return;

    // Calculate route if source and destination are provided

    console.log("source: ", source);
    if (source && destination) {
      const directionsService = new window.google.maps.DirectionsService();
      directionsService.route(
        {
          origin: source,
          destination: destination,
          travelMode: window.google.maps.TravelMode.DRIVING,
        },
        (result, status) => {
          if (status === "OK" && result) {
            setDirections(result);
            const leg = result.routes[0].legs[0];
            setDistance(leg.distance.text);
            setDuration(leg.duration.text);
          } else {
            console.error("Directions request failed:", status);
          }
        }
      );
    }

    // Request nearby drivers if sourceLatLng is available
    if (sourceLatLng && wsConnected && ws.current) {
      ws.current.send(
        JSON.stringify({
          type: "requestRide",
          role: "user",
          latitude: sourceLatLng.lat,
          longitude: sourceLatLng.lng,
        })
      );
      getNearbyDrivers();
    } else {
      alert("Please select a source location first!");
    }
  };

  const getNearbyDrivers = () => {
    if (!ws.current) return;

    ws.current.onmessage = async (event) => {
      try {
        const message = JSON.parse(event.data);
        if (message.type === "nearbyDrivers") {
          await getDriversData(message.drivers);
          console.log("Near by : ", message);
        } else if (message.type === "error") {
          console.error("WebSocket error response:", message.message);
        }
      } catch (error) {
        console.error("Error parsing WebSocket data:", error);
      }
    };
  };

  const sendPushNotification = async (expoPushToken, data) => {
    const message = {
      to: expoPushToken,
      sound: "default",
      title: "New Ride Request",
      body: `Ride from ${sourceLatLng.lat} to ${sourceLatLng.lng} (${destLatLng.lat}, ${destLatLng.lng})`,
      data: { orderData: data },
    };

    try {
      const response = await axios.post(
        "https://binberu.idaprocharity.com/api/v1/admin/push",
        message
      );
      console.log("Push result:", response.data);
    } catch (error) {
      console.error("Push error:", error);
    }
  };

  if (!isLoaded) return <div>Loading Google Maps...</div>;

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <h2 className="text-2xl font-bold">Dispatch Trip</h2>

          {/* Row: Inputs + Distance/Duration */}
          <div className="row mb-3">
            {/* Left Column - Inputs and Get button */}
            {/* Left Column - Inputs and Get button */}
            <div className="col-md-6">
              <div className="card shadow-sm border-0 mb-3">
                <div className="card-body">
                  {/* Source */}
                  <div className="form-group mb-3">
                    <label className="font-weight-bold">
                      <i className="fas fa-map-marker-alt text-danger mr-2"></i>{" "}
                      Source
                    </label>
                    <div className="input-group">
                      <Autocomplete
                        onLoad={(autocomplete) =>
                          (sourceRef.current = autocomplete)
                        }
                        onPlaceChanged={() => {
                          if (sourceRef.current) {
                            const place = sourceRef.current.getPlace();
                            setSource(place.formatted_address || "");
                            if (place.geometry) {
                              setSourceLatLng({
                                lat: place.geometry.location.lat(),
                                lng: place.geometry.location.lng(),
                              });
                            }
                          }
                        }}
                      >
                        <input
                          type="text"
                          value={source}
                          onChange={(e) => setSource(e.target.value)}
                          className="form-control form-control-md w-100"
                          placeholder="Enter Source"
                          style={{ maxWidth: "100%" }}
                        />
                      </Autocomplete>
                    </div>
                  </div>

                  {/* Destination */}
                  <div className="form-group mb-3">
                    <label className="font-weight-bold">
                      <i className="fas fa-flag-checkered text-success mr-2"></i>{" "}
                      Destination
                    </label>
                    <div className="input-group">
                      <Autocomplete
                        onLoad={(autocomplete) =>
                          (destRef.current = autocomplete)
                        }
                        onPlaceChanged={() => {
                          if (destRef.current) {
                            const place = destRef.current.getPlace();
                            setDestination(place.formatted_address || "");
                            if (place.geometry) {
                              setDestLatLng({
                                lat: place.geometry.location.lat(),
                                lng: place.geometry.location.lng(),
                              });
                            }
                          }
                        }}
                      >
                        <input
                          type="text"
                          value={destination}
                          onChange={(e) => setDestination(e.target.value)}
                          className="form-control form-control-md w-100"
                          placeholder="Enter Destination"
                          style={{ maxWidth: "100%" }}
                        />
                      </Autocomplete>
                    </div>
                  </div>

                  {/* Get Button */}
                  <div className="text-center">
                    <button
                      className="btn btn-primary btn-lg px-5 shadow-sm"
                      onClick={handleGetAction}
                    >
                      <i className="fas fa-search-location mr-2"></i> Get Info
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column - Distance, Duration, Pickup Time & Traffic Status */}
            <div className="col-md-6">
              {(distance || duration) && (
                <div className="row">
                  {/* Distance Card */}
                  {distance && (
                    <div className="col-md-6 mb-3 d-flex">
                      <div className="card shadow-sm border-primary flex-fill">
                        <div className="card-body text-center d-flex flex-column justify-content-center">
                          <i className="fas fa-route fa-2x text-primary mb-2"></i>
                          <h5 className="card-title text-primary">Distance</h5>
                          <p
                            className="card-text"
                            style={{ fontSize: "1.5rem", fontWeight: "bold" }}
                          >
                            {distance}
                          </p>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Duration Card */}
                  {duration && (
                    <div className="col-md-6 mb-3 d-flex">
                      <div className="card shadow-sm border-success flex-fill">
                        <div className="card-body text-center d-flex flex-column justify-content-center">
                          <i className="fas fa-clock fa-2x text-success mb-2"></i>
                          <h5 className="card-title text-success">Duration</h5>
                          <p
                            className="card-text"
                            style={{ fontSize: "1.5rem", fontWeight: "bold" }}
                          >
                            {duration}
                          </p>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Estimated Pickup Time Card */}
                  <div className="col-md-6 mb-3 d-flex">
                    <div className="card shadow-sm border-warning flex-fill">
                      <div className="card-body text-center d-flex flex-column justify-content-center">
                        <i className="fas fa-dollar-sign fa-2x text-danger mb-2"></i>
                        <h5 className="card-title text-danger">
                          Estimated Price
                        </h5>
                        <p
                          className="card-text"
                          style={{ fontSize: "1.1rem", fontWeight: "bold" }}
                        >
                          {"Calculating..."}
                          {/* {estimatedPrice ? estimatedPrice : "Calculating..."} */}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Estimated Price Card */}
                  <div className="col-md-6 mb-3 d-flex">
                    <div className="card shadow-sm border-danger flex-fill">
                      <div className="card-body text-center d-flex flex-column justify-content-center">
                        <i className="fas fa-car-side fa-2x text-warning mb-2"></i>
                        <h5 className="card-title text-warning">
                          Estimated Pickup Time
                        </h5>
                        <p
                          className="card-text"
                          style={{ fontSize: "1.1rem", fontWeight: "bold" }}
                        >
                          {"Calculating..."}

                          {/* {pickupTime ? pickupTime : "Calculating..."} */}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="container-fluid mb-4">
            <h3 className="text-xl font-bold mb-2">Nearby Drivers</h3>
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Phone</th>
                  <th>Email</th>
                  <th>Vehicle Type</th>
                  <th>Registration No</th>
                  <th>Status</th>
                  <th>Distance (km)</th>
                  <th style={{ width: "100px" }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {driverLoader ? (
                  <tr>
                    <td colSpan="8" className="text-center">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        {/* <span className="visually-hidden">Loading...</span> */}
                      </div>
                    </td>
                  </tr>
                ) : driverLists.length > 0 ? (
                  driverLists.filter((driver) => driver.status === "active")
                    .length > 0 ? (
                    driverLists
                      .filter((driver) => driver.status === "active")
                      .map((driver) => (
                        <tr key={driver.id}>
                          <td>{driver.name || "Unknown"}</td>
                          <td>{driver.phone_number || "N/A"}</td>
                          <td>{driver.email || "N/A"}</td>
                          <td>{driver.vehicle_type || "N/A"}</td>
                          <td>{driver.registration_number || "N/A"}</td>
                          <td>{driver.status}</td>
                          <td>
                            {driver.distance
                              ? (driver.distance / 1000).toFixed(2)
                              : "N/A"}
                          </td>
                          <td>
                            <button
                              className="btn btn-sm btn-warning mr-1"
                              title="Send"
                              onClick={() =>
                                sendPushNotification(
                                  "ExponentPushToken[ZMVeMJFUYzlTxt-8opi2Q1]",
                                  {
                                    source,
                                    destination,
                                    distance,
                                    duration,
                                    driverId: driver.id,
                                    driverName: driver.name,
                                  }
                                )
                              }
                            >
                              <i className="fas fa-paper-plane fa-sm"></i>
                            </button>
                            <button
                              className="btn btn-sm btn-primary mr-1"
                              title="Call"
                              onClick={() => {
                                const phoneNumber = driver.phone_number; // Get the driver's phone number
                                if (phoneNumber) {
                                  window.location.href = `tel:${phoneNumber}`; // Use the `tel:` protocol to initiate a call
                                } else {
                                  alert("Phone number not available"); // Alert if phone number is not available
                                }
                              }}
                            >
                              <i className="fas fa-phone fa-sm"></i>{" "}
                              {/* Change the icon to a phone icon */}
                            </button>
                          </td>
                        </tr>
                      ))
                  ) : (
                    <tr>
                      <td colSpan="8" className="text-center font-weight-bold">
                        🚗 No active drivers found nearby
                      </td>
                    </tr>
                  )
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center font-weight-bold">
                      🚗 No drivers available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Map Section with Checkbox */}
          <div className="container-fluid mt-4">
            <div className="form-check mb-3">
              <input
                type="checkbox"
                className="form-check-input"
                id="showMapCheckbox"
                checked={showMap}
                onChange={(e) => setShowMap(e.target.checked)}
              />
              <label className="form-check-label" htmlFor="showMapCheckbox">
                Show Map
              </label>
            </div>
            {showMap && (
              <GoogleMap
                mapContainerStyle={{
                  width: "100%",
                  height: "500px",
                  border: "2px solid #51657bff",
                  borderRadius: "8px",
                }}
                center={center}
                zoom={13}
              >
                {directions && <DirectionsRenderer directions={directions} />}
              </GoogleMap>
            )}
          </div>
          {/* </div> */}
        </div>
      </div>
    </div>
  );
};

export default Dispatch;
